import { createUseQueryHook } from './createUseQueryHook';

export const useInfoMessage = createUseQueryHook(
    'get_info_messages',
    { staleTime: Infinity },
);
